import { Link } from "react-router-dom";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { useProducts } from "@/context/ProductsContext";
import { formatPrice } from "@/data/products";
import { Heart, X } from "lucide-react";

export default function Wishlist() {
  const { items, remove } = useWishlist();
  const { add } = useCart();
  const { products } = useProducts();

  return (
    <div className="pt-32 pb-24 bg-ivory min-h-screen" data-testid="wishlist-page">
      <div className="container-lux">
        <p className="overline text-muted-foreground">Saved Pieces</p>
        <h1 className="mt-4 font-serif tracking-tighter text-5xl md:text-7xl font-light">Wishlist</h1>
        {items.length === 0 ? (
          <div className="mt-24 text-center">
            <Heart size={40} strokeWidth={0.6} className="mx-auto" />
            <p className="mt-6 font-serif text-2xl">Nothing saved yet</p>
            <Link to="/collections" className="lux-btn-outline mt-8 inline-block">Discover Pieces</Link>
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {items.map((i) => {
              const p = products.find(x => x.id === i.product_id);
              return (
                <div key={i.product_id} className="group relative">
                  <button onClick={() => remove(i.product_id)} className="absolute top-4 right-4 z-10 w-9 h-9 bg-ivory/85 flex items-center justify-center"><X size={14} strokeWidth={1} /></button>
                  <Link to={p ? `/product/${p.slug}` : "#"} className="block aspect-[3/4] overflow-hidden bg-muted">
                    <img src={i.image} alt={i.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </Link>
                  <p className="mt-4 font-serif text-lg">{i.title}</p>
                  <p className="text-xs text-muted-foreground">{i.subtitle}</p>
                  <p className="text-sm mt-2">{formatPrice(i.price)}</p>
                  {p && <button onClick={() => add(p, p.sizes?.[0]||"", p.colors?.[0]||"", 1)} className="lux-btn-outline mt-4 w-full py-3 text-[10px]">Add To Bag</button>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
